import { Label, LabelProps } from "semantic-ui-react";

type BPLabelProps = LabelProps & {}

export function BPLabel(props: BPLabelProps) {
    return <Label {...props}>{props.children}</Label>;
}